import type { ProjectDocumentsUsageTotal } from "@t3tools/contracts";

export const EMPTY_PROJECTS_USAGE_TOTAL: ProjectDocumentsUsageTotal = {
  docs: 0,
  pages: 0,
  llmPages: 0,
  llmCalls: 0,
  inputTokens: 0,
  outputTokens: 0,
  thinkingTokens: 0,
  cachedTokens: 0,
  totalTokens: 0,
  costUsd: 0,
};

export function sumUsageTotals(
  totals: ReadonlyArray<ProjectDocumentsUsageTotal>,
): ProjectDocumentsUsageTotal {
  const result = { ...EMPTY_PROJECTS_USAGE_TOTAL };
  for (const total of totals) {
    result.docs += total.docs;
    result.pages += total.pages;
    result.llmPages += total.llmPages;
    result.llmCalls += total.llmCalls;
    result.inputTokens += total.inputTokens;
    result.outputTokens += total.outputTokens;
    result.thinkingTokens += total.thinkingTokens;
    result.cachedTokens += total.cachedTokens;
    result.totalTokens += total.totalTokens;
    result.costUsd += total.costUsd;
  }
  return result;
}

export function formatTokens(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value);
}

export function formatTokensMillions(value: number, locale: string): string {
  const millions = value / 1_000_000;
  if (value > 0 && millions < 0.005) {
    return "<0.01";
  }
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(millions);
}

export function formatCostUsd(value: number): string {
  if (value > 0 && value < 0.01) {
    return "<$0.01";
  }
  return `$${value.toFixed(2)}`;
}
